import { VideoControlsList } from '@hakimo-ui/hakimo/types';
import {
  Go2RtcNativePlayer,
  LiveMse,
  LiveWebRtc,
} from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import LiveHls from './LiveHls';

const GO2RTC_URL_PATTERN = /go2rtc\d+\.hakimo\.ai/;

const IFRAME_SERVERS = [
  'live.hakimo.ai',
  'live1.hakimo.ai',
  'live2.hakimo.ai',
  'live3.hakimo.ai',
  'live4.hakimo.ai',
  'mediamtx.hakimo.ai',
  'frp.hakimo.ai',
  'action-cs-vpn.hakimo.ai',
  'sharpvue-vpn.hakimo.ai',
  'go2rtc-ohare.hakimo.ai',
  'go2rtc-elevance.hakimo.ai',
  'dc04tlvhak300.wellpoint.com',
  'vaazplvhak302.wellpoint.com',
  'mcup12702.geico.net',
];

function isGo2RtcUrl(url: string) {
  return GO2RTC_URL_PATTERN.test(url);
}

function isIframeUrl(url: string) {
  return IFRAME_SERVERS.some((server) => url.includes(server));
}

interface Props {
  cameraId: string;
  livestreamUrl?: string;
  controlsList?: VideoControlsList[];
  lockAspectRatio?: boolean;
}

export function LiveViewSwitch(props: Props) {
  const {
    cameraId,
    livestreamUrl,
    controlsList,
    lockAspectRatio = false,
  } = props;

  const hlsLiveView = (
    <LiveHls
      cameraId={cameraId}
      renderAlert={renderAlert}
      open
      lockAspectRatio={lockAspectRatio}
      controlsList={controlsList}
    />
  );

  if (!livestreamUrl) {
    return hlsLiveView;
  }

  if (livestreamUrl.startsWith('ws')) {
    return <LiveMse mseUrl={livestreamUrl} lockAspectRatio={true} />;
  }

  if (isGo2RtcUrl(livestreamUrl)) {
    return <Go2RtcNativePlayer livestreamUrl={livestreamUrl} />;
  }

  if (isIframeUrl(livestreamUrl)) {
    return <LiveWebRtc livestreamUrl={livestreamUrl} />;
  }

  return hlsLiveView;
}

function renderAlert(message: string) {
  return <Alert>{message}</Alert>;
}
